import { useState } from "react";
import { Col, Row } from "react-bootstrap";
import { Field } from "react-final-form";
import { useTranslation } from "react-i18next";
import BMXSelectField from "../../../../../Components/Inputs/BMXSelectField/BMXSelectField";
import BMXTextField from "../../../../../Components/Inputs/BMXTextField/BMXTextField";
import BMXSeparator from "../../../../../Components/Separator/BMXSeparator";
import { GlobalAuthFetch } from "../../../../../Utils/GlobalAuthFetch/GlobalAuthFetch";
import BMXDatePicker from "../../../../../Components/Inputs/BMXDatePicker/BMXDatePicker";
import { updateDashboardByName } from "../../../../../Utils/Sockets";
import { show } from "redux-modal";
import { useDispatch } from "react-redux";
import BMXAsynchronous from "../../../../../Components/Inputs/BMXAsynchronous/BMXAsynchronous";

const BusinessDocumentFormStepOne = (props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  // NEW COMPONENET
  const [contacts, setContacts] = useState([]);
  const REGISTRY_NAME = "contact";

  const { values, form } = props;

  const getSelectedContact = (contact) => {
    if (!contact) return null;
    return contacts.find(
      (el) => el.uuid === contact.value || el.uuid === contact.uuid
    );
  };

  const getData = async (searchTerm) => {
    if (searchTerm?.length > 0) {
      const data = GlobalAuthFetch({
        path: `/contact/findByName/${searchTerm}`,
      });
      const [contactListPayload] = await Promise.all([data]);
      const contactList = contactListPayload?.payload?.data?.map((contact) => {
        return {
          uuid: contact.uuid,
          value: `${contact.name}`,
          ...contact,
        };
      });

      if (contactList?.length > 0) {
        setContacts(contactList);
        return contactList;
      } else {
        setContacts([]);
        return [];
      }
    }
  };

  // useEffect(() => {
  //   getSelectedContact(values?.contact);
  // }, [values?.contact]);

  return (
    <div style={{ justifyContent: "flex-start" }}>
      <BMXSeparator title={t("global:document.basicInformation")} />
      <Row>
        <Col xs={{ span: 12 }}>
          <Field
            currentValues={values}
            className="contact"
            component={BMXAsynchronous}
            getOptionLabel={(option) => {
              if (option.name) return option.name;
              return option;
            }}
            label={`${t("global:document.contact.contact")}*`}
            name="contact"
            options={contacts}
            // disabled={update}
            getData={getData}
            data-cy="client"
            disablePortal={true}
            onClose={() => {
              form.change("representative", null);
            }}
          />
        </Col>

        <Col xs={{ span: 6 }}>
          <Field
            data-cy="representative"
            beforeIcon="people"
            afterIcon="add"
            afterIconSize="18px"
            afterIconClick={() => {
              const contactUuid =
                values?.contact?.uuid || values?.contact?.value;
              const updateSingleRegistry = () =>
                updateDashboardByName(REGISTRY_NAME, contactUuid);
              dispatch(
                show("RepresentativesModal", {
                  loadData: async () => {
                    await getData(values?.contact?.name);
                  },
                  header: t("global:document.representativeAdd"),
                  updateSingleRegistry,
                  uuid: contactUuid,
                })
              );
            }}
            disabled={!values?.contact}
            component={BMXSelectField}
            values={getSelectedContact(values?.contact)?.representatives?.map(
              (el) => ({
                value: el.uuid,
                name: `${el.name || ""} ${el.lastname || ""}`,
              })
            )}
            label={`${t("global:document.representative")}`}
            name="representative"
            renderValue={(el) => {
              return `${el.name || ""} ${el.lastname || ""}`;
            }}
          />
        </Col>
        <Col xs={12}>
          <Field
            component={BMXTextField}
            label={`${t("global:document.title")}*`}
            name="title"
            data-cy="title"
          />
        </Col>
        <Col xs={{ span: 4 }}>
          <Field
            component={BMXDatePicker}
            label={`${t("global:document.expirationDate")}*`}
            name="expirationDate"
            data-cy="expirationDate"
          />
        </Col>
        <Col xs={{ span: 2 }}>
          <Field
            component={BMXTextField}
            fieldtype={"checkbox"}
            label={`${t("global:document.isIndefinite")}`}
            name="indefinite"
            data-cy="indefinite"
          />
        </Col>
      </Row>

      <Row>
        <Col xs={12}>
          <Field
            component={BMXTextField}
            label={`${t("global:document.description")}*`}
            name="description"
            data-cy="description"
          />
        </Col>
      </Row>
    </div>
  );
};

export default BusinessDocumentFormStepOne;
